import React from "react";
import JumboLayout from "@jumbo/components/JumboLayout";
import useJumboLayout from "@jumbo/hooks/useJumboLayout";
import layoutConfig from "./layoutConfig";
import Div from "@jumbo/shared/Div/Div";
import TopNavBar from "app/components/TopNavBar/TopNavBar";
import ContentWrapper from "app/components/ContentWrapper/ContentWrapper";
import Footer from "app/components/Footer";

const PrivatePage = ({ children }) => {
  const { setJumboLayoutOptions } = useJumboLayout();

  React.useEffect(() => {
    setJumboLayoutOptions(layoutConfig);
  }, []);

  return (
    <JumboLayout>
      <Div className="page-wrapper">
        <TopNavBar />
        <ContentWrapper ContentWrapper>{children}</ContentWrapper>
        <Footer />
      </Div>
    </JumboLayout>
  );
};

export default PrivatePage;
